export { Modal } from '@mantine/core'